import React, { ForwardRefExoticComponent, PropsWithoutRef, RefAttributes } from 'react'

export const withProps = function <T>(
  Component: React.FC<T>,
  withProps: T
): ForwardRefExoticComponent<PropsWithoutRef<T> & RefAttributes<any>> {
  return React.forwardRef((props: T, ref) => <Component ref={ref} {...withProps} {...props} />)
}
